// Atajos de teclado globales (PC) y accesibilidad. La interacción con fichas
// (arrastre/toque) la gestiona GameScene con Pointer Events.
export class InputManager {
  constructor(bus) {
    this.bus = bus;
    this.bindings = new Map();
    this._onKey = (e) => this._handle(e);
    window.addEventListener('keydown', this._onKey);
  }

  /** Registra una combinación de teclas: on('Enter', fn), on('ctrl+z', fn), on('Escape', fn). */
  on(combo, fn) {
    this.bindings.set(combo.toLowerCase(), fn);
    return () => this.bindings.delete(combo.toLowerCase());
  }

  _handle(e) {
    // No interceptar cuando se escribe en un campo.
    if (e.target && ['INPUT', 'TEXTAREA'].includes(e.target.tagName)) return;
    const parts = [];
    if (e.ctrlKey || e.metaKey) parts.push('ctrl');
    if (e.shiftKey) parts.push('shift');
    parts.push(e.key.toLowerCase());
    const combo = parts.join('+');
    const fn = this.bindings.get(combo);
    if (fn) {
      e.preventDefault();
      fn(e);
    }
  }

  dispose() {
    window.removeEventListener('keydown', this._onKey);
    this.bindings.clear();
  }
}
